import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { find } from 'lodash';
import FlexView, { FlexViewMain } from '../../views/flexView/FlexView';
import StepHeader from '../../components/stepHeader/StepHeader';
import { PACKAGES_AND_OPTIONS } from '../../common/steps';
import OptionCards from '../../common/optionCards/OptionCards';
import OptionsPage from '../../common/OptionsPage';
import OptionDetails from '../../common/optionDetails/OptionDetails';
import PackageDetails from '../packages/PackageDetails';
import PackageCards from '../../common/packageCards/PackageCards';

const OptionsGroup = ({
  onChange,
  onDetails,
  category,
  isUpdating,
  selectingOption,
}) => {
  if (category?.options?.length <= 0) {
    return null;
  }

  return (
    <>
      <div className="option-category__label">{category.label}</div>
      <section className="options-group__grid">
        <OptionCards
          options={category.options}
          onChange={onChange}
          onDetails={onDetails}
          isUpdating={isUpdating}
          selectingOption={selectingOption}
          analyticsKey={`${category.label.toLowerCase()}`}
        />
      </section>
    </>
  );
};

const PackagesAndOptions = ({ packagesAndOptions, bottomOffset }) => {
  const getCategoryByKey = (categories, key) => find(categories, { key });
  const { categories } = packagesAndOptions;
  const packages = getCategoryByKey(categories, 'packages');
  const options = getCategoryByKey(categories, 'options');
  const accessories = getCategoryByKey(categories, 'accessories');

  const navigate = useNavigate();
  const onClose = () => {
    navigate('');
  };

  return (
    <>
      <FlexView bottomOffset={bottomOffset}>
        <FlexViewMain>
          <StepHeader step={PACKAGES_AND_OPTIONS} />
          <OptionsPage>
            {({ onChange, isUpdating, selectingOption, onDetails }) => (
              <div className="packages_options__container">
                {packages && (
                  <>
                    <div className="option-category__label">
                      {packages.label}
                    </div>
                    <PackageCards
                      options={packages.options}
                      onChange={onChange}
                      isUpdating={isUpdating}
                      selectingOption={selectingOption}
                      stacked={false}
                      analyticsKey={`${packages.label}`}
                    />
                  </>
                )}
                {options && (
                  <OptionsGroup
                    category={options}
                    onChange={onChange}
                    isUpdating={isUpdating}
                    selectingOption={selectingOption}
                    onDetails={onDetails}
                  />
                )}
                {accessories && (
                  <OptionsGroup
                    category={accessories}
                    onChange={onChange}
                    isUpdating={isUpdating}
                    selectingOption={selectingOption}
                    onDetails={onDetails}
                  />
                )}
                <Routes>
                  <Route
                    path="/package/:id"
                    element={
                      <OptionDetails
                        type="package"
                        moreOptions={packages?.options}
                        onClose={onClose}
                        onSelect={(option) => {
                          onChange(option);
                          navigate('');
                        }}>
                        <PackageDetails packages={packages?.options} />
                      </OptionDetails>
                    }
                  />
                </Routes>
              </div>
            )}
          </OptionsPage>
        </FlexViewMain>
      </FlexView>
    </>
  );
};

const mapStateToProps = (state) => {
  const { packagesAndOptions } = state.config;
  return {
    packagesAndOptions,
  };
};

export default connect(mapStateToProps)(PackagesAndOptions);
